// @ts-check

import { Icon, Link } from '@bonprix/design-system';
// @ts-expect-error Don't know how to fix this using JSDoc
import Url from '@core/scripts/helper/url';
import './jsdoc-types.js'
import { getSlugFromNavigationItem, navigationItemIsCurrentPage, slugIsCurrentPage } from './helpers.jsx';

/**
 * References:
 * - https://www.w3.org/WAI/ARIA/apg/patterns/breadcrumb/
 */

/**
 * @param {Object} props
 * @param {NavigationEntry} props.cdaEntry
 */
export const ServicePageBreadcrumbs = ({ cdaEntry }) => {
	const breadcrumbs = getBreadcrumbs(cdaEntry);

	if (breadcrumbs.length <= 0) return null;

	return (
		<nav aria-label="Breadcrumb" className="service-page-breadcrumbs">
			<ol>
				{breadcrumbs.map(({ title, slug }, index) => (
					<li key={ slug } className="service-page-breadcrumbs__item">
						{ index > 0 && (
							<Icon
								variant="arrow-right"
								className="service-page-breadcrumbs__icon"
							/>
						)}

						<Link
							href={ Url.toAbsolute(slug) }
							aria-current={ index === breadcrumbs.length - 1 ? "page" : null }
							hideUnderline={ index !== breadcrumbs.length - 1 }
						>
							{ title }
						</Link>
					</li>
				))}
			</ol>
		</nav>
	)
}

/**
 * Finds the navigation branch for a given slug
 * @param {NavigationEntry} navigation
 */
const getBreadcrumbs = (navigation) => {
	const breadcrumbs = [
		{ title: navigation.fields.title, slug: navigation.fields.slug }
	];

	if (slugIsCurrentPage(navigation.fields.slug)) return breadcrumbs;

	outer:
	for (const item of navigation.fields.items) {
		if (item.sys.contentType.sys.id === "navigationItem") {
			const navigationItem = /** @type {NavigationItemEntry} */ (item);
			if (navigationItemIsCurrentPage(navigationItem)) {
				breadcrumbs.push({ title: navigationItem.fields.title, slug: getSlugFromNavigationItem(navigationItem) });
				break outer;
			}

			for (const subItem of item.fields.items) {
				if (navigationItemIsCurrentPage(subItem)) {
					const navigationItem = /** @type {NavigationItemEntry} */ (item);
					breadcrumbs.push(
						{ title: navigationItem.fields.title, slug: getSlugFromNavigationItem(navigationItem) },
						{ title: subItem.fields.title, slug: getSlugFromNavigationItem(subItem) }
					);
					break outer;
				}
			}
		}

		if (item.sys.contentType.sys.id === "navigationSection") {
			for (const sectionItem of item.fields.items) {
				if (navigationItemIsCurrentPage(sectionItem)) {
					breadcrumbs.push({ title: sectionItem.fields.title, slug: getSlugFromNavigationItem(sectionItem) });
					break outer;
				}

				if ("items" in sectionItem.fields) {
					for (const subItem of sectionItem.fields.items) {
						if (navigationItemIsCurrentPage(subItem)) {
							breadcrumbs.push(
								{ title: sectionItem.fields.title, slug: getSlugFromNavigationItem(sectionItem) },
								{ title: subItem.fields.title, slug: getSlugFromNavigationItem(subItem) }
							);
							break outer;
						}
					}
				}
			}
		}
	}

	return breadcrumbs;
}
